import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class CompanyCustomerID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
